// HOAD: Carrossel de vídeos nativo. Sem Swiper, sem Fancybox — o scroll-snap
// do CSS já cuida do arrasto suave, isso aqui só liga/desliga o autoplay
// conforme o vídeo entra/sai da tela, o mute e as setas de navegação.
(function () {
  function setup(root) {
    var track = root.querySelector('[data-hoad-video-track]');
    var slides = root.querySelectorAll('[data-hoad-video-slide]');
    var prevBtn = root.querySelector('[data-hoad-video-prev]');
    var nextBtn = root.querySelector('[data-hoad-video-next]');
    var autoplayInView = root.dataset.autoplayInView === 'true';

    if (!track || !slides.length) return;

    if (autoplayInView && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.6) {
              video.play().catch(function () {});
            } else {
              video.pause();
            }
          });
        },
        { threshold: [0, 0.6, 1] }
      );
      slides.forEach(function (slide) {
        observer.observe(slide);
      });
    }

    slides.forEach(function (slide) {
      var video = slide.querySelector('video');
      var muteBtn = slide.querySelector('[data-hoad-video-mute]');
      if (!video || !muteBtn) return;
      muteBtn.addEventListener('click', function () {
        video.muted = !video.muted;
        muteBtn.classList.toggle('is-unmuted', !video.muted);
        muteBtn.setAttribute('aria-label', video.muted ? 'Ativar som' : 'Silenciar');
      });
    });

    function scrollByOneSlide(direction) {
      var slide = slides[0];
      var gap = 12;
      var amount = (slide.getBoundingClientRect().width + gap) * direction;
      track.scrollBy({ left: amount, behavior: 'smooth' });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollByOneSlide(-1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollByOneSlide(1);
      });
    }

    function updateNavVisibility() {
      if (!prevBtn || !nextBtn) return;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      prevBtn.hidden = atStart;
      nextBtn.hidden = atEnd;
    }

    track.addEventListener('scroll', updateNavVisibility, { passive: true });
    window.addEventListener('resize', updateNavVisibility);
    updateNavVisibility();
  }

  document.querySelectorAll('[data-hoad-video-carousel]').forEach(setup);
})();
